export default __webpack_public_path__ + "static/media/background.8164b2eb.jpeg";